import { IBadge } from './types'
import css from './index.module.scss'


/** Компонент Badge */
export const Badge = ({
    children, 
    background = '#28ac28', 
    color = 'white', 
    isVisible = true,
    top, 
    left, 
    right, 
    bottom,
}: IBadge) => {
    /** Стили компоненты */
    const elementStyle: React.CSSProperties = {
        color: color,
        background: background,
        border: '.5px solid #fff',

        display: isVisible ? 'flex' : 'none',

        top: top,
        left: left,
        right: right,
        bottom: bottom,
    }
    
    return <div className={`${css.container}`} style={elementStyle}>
        <p>{children}</p>
    </div>
}